//import _ from 'lodash';
import { connect } from 'react-redux';
import { halt, resume, getStatus, run } from '../modules/notifier';
import { bindActionCreators } from 'redux';


const mapStateToProps = (state) => {
	let notifierStatus;

	if (state.notifier.notifierStatus)  {
		notifierStatus = state.notifier.notifierStatus;
	}

	return {
		notifierStatus,
		userMap : state.maps.user,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	haltNotifier : halt,
	runNotifier : run,
	resumeNotifier : resume,
	getNotifierStatus : getStatus,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
